import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

const NOOP_FN = () => {}

class Video extends Component {
  componentDidMount () {
    const { isAutoPlaying, onVideoEnded } = this.props
    if (this._videoEl && isAutoPlaying) {
      this._videoEl.load()
      this._videoEl.play()
      this._videoEl.addEventListener('ended', onVideoEnded)
    }
  }
  componentDidUpdate (prevProps) {
    const { src, isAutoPlaying, isPlaying, onVideoEnded } = this.props

    if (isAutoPlaying && !prevProps.isAutoPlaying) {
      this._videoEl.play()
      return
    }

    const newSrc = prevProps.src !== src
    const newIsPlaying = prevProps.isPlaying && !isPlaying
    const newOnVideoEnded = prevProps.onVideoEnded !== onVideoEnded
    // if props changed, remove any old 'ended' listener
    if (prevProps.onVideoEnded && (newSrc || newIsPlaying || newOnVideoEnded)) {
      this._videoEl.removeEventListener('ended', prevProps.onVideoEnded)
    }

    // then load new video if necessary,
    // and handle stop/play action
    if (newSrc) {
      this._videoEl.load()
      if (this.props.isAutoPlaying) {
        this._videoEl.play()
      }
    } else if (prevProps.isPlaying !== isPlaying) {
      if (isPlaying) {
        this._videoEl.play()
      } else {
        this._videoEl.pause()
      }
    }

    // finally, need to setup new 'ended' listener
    // (except for if we just paused the video)
    if (!(newIsPlaying && !isPlaying)) {
      this._videoEl.addEventListener('ended', onVideoEnded)
    }
  }
  componentWillUnmount () {
    this._videoEl.removeEventListener('ended', this.props.onVideoEnded)
  }
  render () {
    const {
      className,
      src,
      muted,
      loop,
      controls,
      preload,
      poster,
      scrollAutoplayEnabled
    } = this.props
    return (
      <video
        className={classnames(className, 'fit')}
        ref={el => {
          this._videoEl = el
        }}
        muted={muted}
        controls={!scrollAutoplayEnabled && controls}
        poster={poster}
        loop={loop}
        preload={preload}
      >
        <source src={src} type='video/mp4' />
      </video>
    )
  }
}

Video.propTypes = {
  src: PropTypes.string.isRequired,
  controls: PropTypes.bool,
  poster: PropTypes.string,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
  preload: PropTypes.string,
  onVideoEnded: PropTypes.func,
  isPlaying: PropTypes.bool,
  isAutoPlaying: PropTypes.bool
}

Video.defaultProps = {
  loop: true,
  muted: true, // beccause most of the videos we use are silent
  controls: true, // controls disabled when scrollAutoplayEnabled
  onVideoEnded: NOOP_FN
}

export default Video



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Video.js